// extracted by mini-css-extract-plugin
export default {"galaxy__container":"GalaxyBackground_galaxy__container__H3w4T","galaxy":"GalaxyBackground_galaxy__+HZEG","noPadding":"GalaxyBackground_noPadding__bggjh"};